import { Box, Text } from '@vouched.id/vault';
import React from 'react';
import { ImageSlider } from '../jobs/image-slider';
import { dropdownWrapperStyle } from './dropdowns/utils';
import { DigitalID } from './mdl/DigitalID';
import { JobImageType } from 'models/jobs/jobs';
export const JobImages = ({ frontIdImages, backIdImages, userImages, isReverification, includeBarcode, hasPDF417Back, digitalIDData }) => {
    // Reverification: show reference (source/userImages) then new image
    // (dest/frontIdImages) as "Original" -> "Latest submission".
    const firstSliderImages = isReverification ? userImages : frontIdImages;
    const lastSliderImages = isReverification ? frontIdImages : userImages;
    const hasFrontIdImages = firstSliderImages.length > 0;
    const hasBackIdImages = backIdImages.length > 0 ||
        (includeBarcode && !!hasPDF417Back && !isReverification);
    const hasUserImages = lastSliderImages.length > 0;
    if (!digitalIDData &&
        !hasFrontIdImages &&
        !hasBackIdImages &&
        !hasUserImages) {
        return React.createElement(Text, null, "No images have been submitted yet for this job.");
    }
    return (React.createElement(Box, { display: "grid", marginBottom: "spacing.large", style: {
            ...dropdownWrapperStyle,
            columnGap: '5px',
            gridTemplateColumns: digitalIDData
                ? 'min-content 33%'
                : 'repeat(3, calc(100% / 3 - 5px))'
        } },
        digitalIDData && React.createElement(DigitalID, { data: digitalIDData }),
        !digitalIDData && hasFrontIdImages && (React.createElement(ImageSlider, { imageType: JobImageType.IDFront, images: firstSliderImages, selectedImage: 0, type: isReverification ? 'Original' : '' })),
        !digitalIDData &&
            hasBackIdImages &&
            (backIdImages.length ? (React.createElement(ImageSlider, { imageType: JobImageType.IDBack, images: backIdImages, selectedImage: 0 })) : (React.createElement("div", { style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    border: '1px outset rgba(0, 0, 0, 0.2)',
                    borderRadius: '5px'
                } }, "Barcode was not able to be captured"))),
        hasUserImages && (React.createElement(ImageSlider, { imageType: JobImageType.Selfie, images: lastSliderImages, selectedImage: 0, type: isReverification ? 'Latest submission' : '' }))));
};
